import Validator from 'validatorjs';
import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { QUOTE_QUESTIONS } from "../../AppConstants";
import appStore from '../../state/store';

const VALIDATION = {
    INVALID_GARAGING_STATE: "Your car must be garaged in the state where you live"
};

Validator.register('valid_garaging_state', function (value) {
    var mainStateCode = appStore.getState().stateCode;
    console.log("mainStateCode=" + mainStateCode);
    return mainStateCode === value;
});

const rules = {
    vehicleUse: 'required',
    valueMiles: 'required',
    mileage: 'required_if:vehicleUse,' + QUOTE_QUESTIONS.VEHICLE_USE.COMMUTING,
    parkAtHome: 'required',
    garagingAddress: {
        street: 'required_if:parkAtHome,No',
        city: 'required_if:parkAtHome,No',
        zipCode: 'required_if:parkAtHome,No',
        stateCode:'valid_garaging_state'
    }
};

const customErrorMessages = {
    "valid_garaging_state": VALIDATION.INVALID_GARAGING_STATE,
};

export const allFieldsValidation = (data) => {
    return allFieldsValidationCommon(data, rules, { ...customErrorMessagesCommon, ...customErrorMessages });
};